export default __webpack_public_path__ + "1559a1b7e79490d58549133d9d8252c0.svg";